module.exports = __webpack_public_path__ + "static/media/delete-document-icon.9d23105b.svg";